module.exports = __webpack_public_path__ + "img/icon-call.764413d4.svg";